import React, { Component, } from 'react'
import {CCDp, CCIcon, strings} from "./../../cc-imports";
import './../../styles/css/components/CCLBStatusItem/cc-lb-status-item.css'

import CCCoinPile from "../CCCoinPile/CCCoinPile";

import PropTypes from 'prop-types';

class CCLBStatusItem extends Component {

    static propTypes = {
        className : PropTypes.string
    }

    static defaultProps = {
        first: false,
        className: ''
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    _getTitle(lbStatus, currentUser){
        if(currentUser && lbStatus.user && lbStatus.user.id==currentUser.id){
            return strings('you');
        }
        else {
            return lbStatus.user.displayName
        }
    }

    render() {
       const {lbStatus, currentUser, className} = this.props;
        return (
            <div className={"flex-container lb-parent "+className} >
                <div className={"flex-container lb-parent-sub"} disabled={true}>
                    <div className="flex-container lb-cointainer3">
                        <h1 className={'flex-container lb-rank'}>{lbStatus.rank}</h1>
                        <div className={'flex-container'} style={{flex:1, position:'relative'}}>
                            {/*<CCDp imageClassName={'lb-dp-image'} className={'lb-dp-parent'} isWinner={true} user={lbStatus.user}/>*/}
                            <CCDp isWinner={true} user={lbStatus.user} width={50} imgClass={'leader-board-dp'}/>
                            {
                                lbStatus.rewardWinning &&
                                <div className="flex-container lb-winner">
                                    <CCIcon  onPress={this.props.onPress} className={'cc-icon-xxs'} type={'winnerBadge'}/>
                                </div>

                            }
                        </div>
                    </div>
                    <div className="flex-container lb-cointainer">
                        <h1 className={'lb-user-name'}>{this._getTitle(lbStatus,currentUser)}</h1>
                    </div>
                    <div className="flex-container lb-cointainer2 alt-right">
                        <CCCoinPile theme={'dark'} textClass={'coin-pile-font'} iconClass={'coin-pile-icon'} coins={lbStatus.coins}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default CCLBStatusItem


// WEBPACK FOOTER //
// ./src/app/components/CCLBStatusItem/CCLBStatusItem.js